export default "__VITE_ASSET__CfWQ1Ohs__"